export class NotifyContactsUploadActionInfo {
    public ListId: number;
    public ContactIds: Array<number>;
  
    constructor(init: any) {
      this.ListId = init.ListId;
      this.ContactIds = init.ContactIds;
    }
  }